module.exports = __webpack_public_path__ + "img/play-03.70a777ba.jpg";